import { Skeleton } from "antd";
import { useMyContext } from "../../../entities/context";
import { DividerThin } from "../../../shared";
import { ReactComponent as More } from '../../../assets/images/icon/more.svg'
import '../index.css'

const CommunitySkeleton = () => {
    const { topHeight } = useMyContext();

    return <div style={{ paddingTop: (topHeight + 'px'), position: 'fixed', zIndex: 3, backgroundColor: 'white', maxHeight: '100vh', height: '100vh', width: '100vw', overflowY: 'hidden' }}>
        <div style={{ padding: '16px 20px', marginBottom: '16px' }}>
            <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '27px', width: '196px' }} />
        </div>

        <div style={{ display: 'flex', textAlign: 'center', marginBottom: '8px' }}>
            <div style={{ flex: 1, paddingTop: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '52px' }} />
            </div>
            <div style={{ flex: 1, paddingTop: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '52px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '2px' }} />

        <div style={{ padding: '24px 20px 20px' }}>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '36px', width: '36px' }} />
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '36px', width: '36px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '1px' }} />

        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
                <More fill="var(--secondarys400)" />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '12px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '222px', width: '100%' }} />
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '1px' }} />

        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
                <More fill="var(--secondarys400)" />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '12px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '405px', width: '100%' }} />
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '1px' }} />

    </div>
}

export default CommunitySkeleton